import { combineReducers, } from 'redux'
import authReducer from './authReducer'
import getPaymentMethodsReducer from './getPaymentMethodsReducer'
import deletePaymentMethodReducer from './deletePaymentMethodReducer'
import addPaymentMethodReducer from './addPaymentMethodReducer'
import settingsReducer from './settingsReducer'
import deleteAccountReducer from './deleteAccountReducer'
import getDownloadAccessReducer from './getDownloadAccessReducer'

export default combineReducers({
  auth: authReducer,
  getPaymentMethods: getPaymentMethodsReducer,
  deletePaymentMethod: deletePaymentMethodReducer,
  addPaymentMethod: addPaymentMethodReducer,
  settings: settingsReducer,
  deleteAccount: deleteAccountReducer,
  getDownloadAccess: getDownloadAccessReducer,
})
